import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UiComponentsModule } from './ui/ui-components.module';
import { ToastComponent } from './components';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MsalModule, MsalInterceptor,MsalService } from '@azure/msal-angular';
//import { MsalService } from './services/msal.service';

import { MSAL_CONFIG_CASP } from './services/msal.service';
import { RenewTokenInterceptor } from './services/renew-token.interceptor';
import * as Hammer from 'hammerjs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExecutionSidebarCustomSFRComponent } from './components/execution-sidebar-custom-sfr/execution-sidebar-custom-sfr.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserCacheLocation } from '@azure/msal-browser';
import { AuthInterceptor } from './services/auth.interceptor';
import { FormReplayProtectionInterceptor } from './services/form-replay-protection.interceptor';
import { ErrorInterceptor } from './services/error.interceptor';
// import { Logger, LogLevel } from 'msal';
// import { RenewTokenInterceptor } from './services/renew-token.interceptor';

/* export function loggerCallback(logLevel, message, piiEnabled) {
  // console.log('message', message);
} */

// export const protectedResourceMap: any = [
    // [environment.baseUrl, environment.scopeUri, [ 'user.read', 'openid', 'profile' ]],
  // ['https://graph.microsoft.com/v1.0/me', ['user.read']]
// ];
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
  swipe: { direction: Hammer.DIRECTION_ALL },
  };
}; 
export const protectedResourceMap: any =
    [
        [environment.baseUrl, environment.scopeUri
        ]
    ];


// tslint:disable-next-line: max-line-length
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({ declarations: [
        AppComponent,
        ToastComponent,
        // @@changedbybamba@@ @@removeme@@
        /* OpvComparatorMainComponent,
        OpvComparatorSingleProductDetailsComponent,
        OpvComparatorFiltersComponent */
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        
        AppRoutingModule,
        NgbModule,
        NgSelectModule,
        UiComponentsModule,
        HammerModule,
        BrowserAnimationsModule,
        MsalModule.forRoot(MSAL_CONFIG_CASP, {
            // popUp: !isIE,
            protectedResourceMap: new Map(protectedResourceMap)
        }),
        BrowserModule,
        AppRoutingModule], providers: [
        HttpClient,
        MsalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {   provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FormReplayProtectionInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RenewTokenInterceptor,
            multi: true
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
